// SubscriptionPlansModal
import React from 'react';

const plans = [
    {
        key: 'user_pro',
        targetModel: 'User',
        title: 'Личный PRO',
        price: 5000,
        label: 'Для частного мастера',
        description: 'Личный доступ к 3D-калькулятору без полноценного офисного тарифа.',
        features: [
            'Личный 3D-калькулятор',
            'До 50 личных сцен в месяц',
            'Право создать 1 базовый офис',
            'История личных заказов',
            'Автопродление с личного баланса'
        ]
    },
    {
        key: 'office_calculator',
        targetModel: 'Office',
        title: 'Офис Калькулятор',
        price: 15000,
        label: 'Офисный тариф',
        description: 'Для офиса, которому нужен 3D-калькулятор, сотрудники и оформление заказов.',
        features: [
            '3D-калькулятор офиса',
            'До 100 офисных сцен в месяц',
            'До 3 сотрудников',
            'До 300 товаров',
            'Офисный баланс',
            'Автопродление с баланса офиса'
        ]
    },
    {
        key: 'office_pro',
        targetModel: 'Office',
        title: 'Офис PRO',
        price: 20000,
        label: 'Полный офисный тариф',
        description: 'Для полноценного управления офисом, сотрудниками, товарами, ценами и заказами.',
        features: [
            'Всё из тарифа Офис Калькулятор',
            'До 10 сотрудников',
            'До 3000 товаров',
            'Безлимитные офисные сцены',
            'Персональные цены офиса',
            'Расширенная работа с заказами'
        ]
    }
];

const SubscriptionPlansModal = ({
    visible,
    onClose,
    onBuy,
    loading,
    balance = 0,
    targetModel = 'User',
    targetTitle = '',
    currentSubscription = null
}) => {
    if (!visible) return null;

    const formatMoney = (value) => `${Number(value || 0).toLocaleString('ru-RU')} ₽`;

    const visiblePlans = plans.filter((plan) => plan.targetModel === targetModel);

    const hasActiveSubscription =
        currentSubscription?.validUntil &&
        new Date(currentSubscription.validUntil) > new Date();

    const currentPlan = currentSubscription?.plan || 'none';

    const getPlanButtonText = (plan, enoughMoney, isCurrentPlan) => {
        if (loading) return 'Обработка...';

        if (hasActiveSubscription && isCurrentPlan) {
            return 'Уже активна';
        }

        if (hasActiveSubscription && !isCurrentPlan) {
            return 'Смена тарифа пока недоступна';
        }

        if (!enoughMoney) {
            return 'Недостаточно средств';
        }

        return 'Купить и включить автопродление';
    };

    const getPlanClassName = (enoughMoney, isCurrentPlan) => {
        if (hasActiveSubscription && isCurrentPlan) {
            return 'subscription-modal__buy active';
        }

        if (hasActiveSubscription) {
            return 'subscription-modal__buy disabled';
        }

        return enoughMoney ? 'subscription-modal__buy' : 'subscription-modal__buy disabled';
    };

    return (
        <div className="subscription-modal" onClick={onClose}>
            <div className="subscription-modal__body" onClick={(e) => e.stopPropagation()}>
                <div className="subscription-modal__header">
                    <div>
                        <h3>Выберите подписку</h3>
                        <p>
                            {targetModel === 'Office'
                                ? `Подписка будет активирована для офиса${targetTitle ? `: ${targetTitle}` : ''}.`
                                : 'Подписка будет активирована для вашего аккаунта.'}
                        </p>
                    </div>

                    <button className="subscription-modal__close" onClick={onClose}>
                        ✕
                    </button>
                </div>

                <div className="subscription-modal__balance">
                    Доступный баланс: <b>{formatMoney(balance)}</b>
                </div>

                {hasActiveSubscription && (
                    <div className="subscription-modal__active-notice">
                        У вас уже есть активная подписка. Повторная покупка текущего тарифа заблокирована, чтобы случайно не списать деньги ещё раз.
                    </div>
                )}

                <div className="subscription-modal__notice">
                    После покупки включается автопродление с внутреннего баланса. Автопродление можно отключить в любой момент. Доступ сохранится до конца оплаченного периода. Возврат средств за уже оплаченный период не производится.
                </div>

                <div className="subscription-modal__plans">
                    {visiblePlans.map((plan) => {
                        const enoughMoney = Number(balance || 0) >= plan.price;
                        const isCurrentPlan = hasActiveSubscription && currentPlan === plan.key;
                        const disabled = loading || !enoughMoney || hasActiveSubscription;

                        return (
                            <div
                                className={isCurrentPlan ? 'subscription-modal__plan current' : 'subscription-modal__plan'}
                                key={plan.key}
                            >
                                <div className="subscription-modal__plan-label">
                                    {isCurrentPlan ? 'Текущий тариф' : plan.label}
                                </div>

                                <h4>{plan.title}</h4>

                                <div className="subscription-modal__price">
                                    {formatMoney(plan.price)} / месяц
                                </div>

                                <p className="subscription-modal__description">{plan.description}</p>

                                <ul>
                                    {plan.features.map((feature) => (
                                        <li key={feature}>{feature}</li>
                                    ))}
                                </ul>

                                <button
                                    className={getPlanClassName(enoughMoney, isCurrentPlan)}
                                    disabled={disabled}
                                    onClick={() => onBuy(plan.key)}
                                >
                                    {getPlanButtonText(plan, enoughMoney, isCurrentPlan)}
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPlansModal;